import i18next from "i18next";
import {initReactI18next} from "react-i18next";
import ReactPostProcessor from "./ReactPostProcessor";
import en from "../../resources/en.json";
import {generateBork} from "./bork";

const initialize = () => {
  const instance = i18next.createInstance(),
    bork = generateBork(en);

  instance
    .use(new ReactPostProcessor())
    .use(initReactI18next)
    .init({
      compatibilityJSON: "v4",
      lng: "en",
      fallbackLng: "en",
      postProcess: ["reactPostprocessor"],
      resources: {
        en,
        "en-BORK": bork
      },
      initImmediate: false,
      interpolation: {
        escapeValue: false, // React already does escaping
        format(value, fmt) {
          if (fmt === "number" && !isNaN(value)) {
            return Number(value).toLocaleString();
          }

          return value;
        }
      }
    });

  return instance;
};

const Configuration = () => {
  if (!window.atsSecurityRibbonLocalization) {
    window.atsSecurityRibbonLocalization = initialize();
  }
  return window.atsSecurityRibbonLocalization;
};

export default Configuration();
